import { format } from 'date-fns';
import React, { useState } from 'react';
import { DEFAULT_API_URL, DEFAULT_DATE_FORMATE } from '../../../constents';
import { Link } from 'react-router-dom';
import IntakeResendPop from './IntakeResendPop';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import { useSelector } from 'react-redux';

function IntaleList({ item, handleReload }) {
  const [closeResedPopup, setCloseResedPopup] = useState(false);
  const [conFirmDelete, setConFirmDelete] = useState({
    status: false,
    data: null,
  });
  const { user } = useSelector((store) => store.auth);
  const handleResend = () => {
    setCloseResedPopup(true);
  };

  const handleRemoveFromList = (id, actStatus) => {
    setConFirmDelete({
      status: true,
      data: { id: id, actStatus: actStatus },
    });
  };

  const handleRemoveFromListConfirm = async (id, actStatus) => {
    try {
      const response = await post('api/patient/intake/updateIntakeActive', {
        intakeId: id,
        intakeActive: actStatus,
        loginUserId: user?.id,
      });

      if (response.status === 200) {
        if (response.data?.status === true) {
          setUiMessage('suc', response.data?.message);
        } else {
          setUiMessage('err', response.data?.message);
        }

        handleReload();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const openIntakeReview = async (
    dob = '',
    intakeId = 0,
    userType = 1,
    formId = 0
  ) => {
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/checkLogin',
        {
          intakeId: intakeId,
          dob: dob,
          userType: userType,
          formId: formId,
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        if (parseInt(response.data?.status) === 1) {
          let url;
          if (response.data?.formId !== '') {
            url = `${DEFAULT_API_URL}/registration/profile/index/${response.data?.patientId}/${response.data?.intakeId}/${response.data?.userType}/${response.data?.formId}/${response.data?.ch_external_link_key}`;
          } else {
            url = `${DEFAULT_API_URL}/registration/profile/index/${response.data?.patientId}/${response.data?.intakeId}/${response.data?.userType}/0/${response.data?.ch_external_link_key}`;
          }
          window.open(url, '_blank');
        } else if (parseInt(response.data?.status) === 0) {
          setUiMessage('err', 'Wrong User Credentials');
        } else if (parseInt(response.data?.status) === 2) {
          setUiMessage(
            'err',
            'Link has been expire.Please contact to adminstrator!'
          );
        } else if (response.data?.status === 3) {
          setUiMessage(
            'err',
            'Unable to access this portal as it is not filled by patient till now.Please contact to adminstrator!'
          );
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  return (
    <>
      <span className="pacolm5">
        {format(new Date(item.added_date), DEFAULT_DATE_FORMATE)}
      </span>
      <span className="pacolm5">{item.provider}</span>
      <span className="pacolm5">{item.sentBy}</span>
      <span className="pacolm5">{item.chart_number}</span>
      <span
        className="pacolm4"
        dangerouslySetInnerHTML={{
          __html: item?.patStr,
        }}
      ></span>
      <span className="pacolm5">{item.visit_date}</span>
      <span className="pacolm5">{item.intakeStatus}</span>
      <span className="pacolm4">
        {(() => {
          if (item.intake_status === '0' || item.intake_status === '1') {
            return (
              <>
                <Link className="intake-link" onClick={handleResend} to="#">
                  Resend
                </Link>
                <span>|</span>
                <Link
                  className="intake-link"
                  onClick={() =>
                    openIntakeReview(
                      item?.date_of_birth,
                      item?.id,
                      user?.userType
                    )
                  }
                >
                  View
                </Link>
                <span>|</span>
                <Link
                  className="intake-link"
                  onClick={() =>
                    handleRemoveFromList(item?.id, item?.active_status)
                  }
                >
                  Remove from List
                </Link>
              </>
            );
          } else if (item.intake_status === '2') {
            return (
              <>
                <Link
                  className="intake-link"
                  onClick={() =>
                    openIntakeReview(
                      item?.date_of_birth,
                      item?.id,
                      user?.userType
                    )
                  }
                >
                  Review
                </Link>
                <span>|</span>
                <Link
                  className="intake-link"
                  onClick={() =>
                    handleRemoveFromList(item?.id, item?.active_status)
                  }
                >
                  Remove from List
                </Link>
              </>
            );
          } else if (item.intake_status === '3') {
            return (
              <>
                <Link
                  className="intake-link"
                  onClick={() =>
                    openIntakeReview(
                      item?.date_of_birth,
                      item?.id,
                      user?.userType
                    )
                  }
                >
                  View
                </Link>
                <span>|</span>
                <Link
                  className="intake-link"
                  onClick={() =>
                    openIntakeReview(
                      item?.date_of_birth,
                      item?.id,
                      user?.userType
                    )
                  }
                >
                  Reconcile
                </Link>
                <span>|</span>
                <Link
                  className="intake-link"
                  onClick={() =>
                    handleRemoveFromList(item?.id, item?.active_status)
                  }
                >
                  Remove from List
                </Link>
              </>
            );
          } else if (item.intake_status === '4') {
            return (
              <>
                <Link
                  className="intake-link"
                  onClick={() =>
                    openIntakeReview(
                      item?.date_of_birth,
                      item?.id,
                      user?.userType
                    )
                  }
                >
                  View
                </Link>
                <span>|</span>
                <Link
                  className="intake-link"
                  onClick={() =>
                    handleRemoveFromList(item?.id, item?.active_status)
                  }
                >
                  Remove from List
                </Link>
              </>
            );
          }
        })()}
      </span>
      {closeResedPopup && (
        <IntakeResendPop
          handleClose={() => setCloseResedPopup(false)}
          intakeDetail={item.intakeDetails && item.intakeDetails[0]}
          handleReload={handleReload}
        />
      )}
      {conFirmDelete?.status && (
        <ConfirmDialog
          title="Confirm"
          bodytext="Do you want to delete this task?"
          sucPrams={111}
          closeDialog={() =>
            setConFirmDelete((prev) => ({ ...prev, status: false }))
          }
          successDialog={() =>
            handleRemoveFromListConfirm(
              conFirmDelete?.data?.id,
              conFirmDelete?.data?.actStatus
            )
          }
        />
      )}
    </>
  );
}

export default IntaleList;
